export default __webpack_public_path__ + "static/media/python.09347921.svg";